import { Factory } from 'rosie';

Factory.define('ErrorNotification');

Factory.define('ErrorNotificationWithDefaults')
  .extend('ErrorNotification')
  .attr('id', 'some-error-notification-id')
  .attr('message', 'some-error-message');



// WEBPACK FOOTER //
// ./factories/error_notification_factory.js